import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { ILensActions } from '../types/ILensAction';

export class GetLensActionsRequest extends Request<ISingleIdParams, ILensActions> {
  constructor(id: string) {
    super('getLensActions', { id: id });
  }
}
